import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBranchSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBranchSimple"><Path d="M18 2.25C20.0711 2.25 21.75 3.92893 21.75 6C21.75 8.07107 20.0711 9.75 18 9.75C16.1961 9.75 14.6897 8.47636 14.3311 6.7793C10.3084 7.10218 7.10218 10.3084 6.7793 14.3311C8.47636 14.6897 9.75 16.1961 9.75 18C9.75 20.0711 8.07107 21.75 6 21.75C3.92893 21.75 2.25 20.0711 2.25 18C2.25 16.1857 3.53824 14.6716 5.25 14.3242V3H6.75V9.80566C8.36308 7.24903 11.1297 5.49514 14.3203 5.27539C14.6579 3.55111 16.1768 2.25 18 2.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBranchSimple;
